import { PAGE_LOADER,NAVBAR_ORIENTATION } from "./actionTypes"

export const togglePageLoader = message => {
  return {
    type: PAGE_LOADER,
    payload: message,
  }
}

export const changeOrientation = message => {
  return {
    type: NAVBAR_ORIENTATION,
    payload: message,
  }
}

